import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import toast from "react-hot-toast";
import apis from "../../../../lib/apis/apis";
import {apiHeaders, apiHeadersImage} from "../../../../lib/apiHeader";


export const storePromo = createAsyncThunk('storePromo', async (data,{dispatch}) => {
  try {
      const response = await axios.post(apis.promo_code_create, {...data},{
          headers: apiHeaders()
      })
      if (response?.data?.success==='true'){
        await dispatch(getPromoCodes())

        return  response.data
    }else {
        return response?.data
    }

  }catch (err){
    console.log(err)
      if (err?.response?.status!==200){
          toast.error(err?.response?.data?.message,{duration:4000})
      }  
      if (err?.response?.status!==200){

          return {
              data : [],
              errors:err?.response?.data?.message

          }
      }
  }
})
// 
export const updatePromoCode = createAsyncThunk('updatePromoCode', async (data, { dispatch }) => {
    try {
        const response = await axios.post(apis.update_promo, { ...data }, {
            headers: apiHeaders()
        })

        if (response?.data?.success === 'true') {
            await dispatch(getPromoCodes())
            return response.data
        } else {
            // Handle non-success response (if your API returns success=false for validation errors)
            return {
                error: true,
                message: response?.data?.message || 'Operation failed',
                errors: response?.data?.errors || {}
            }
        }
    } catch (err) {
        console.log(err)

        // Handle validation errors (422 Unprocessable Entity is common for validation errors)
        if (err?.response?.status === 422) {
            toast.error(err.response.data?.message, { duration: 4000 })
            return {
                error: true,
                message: err.response.data?.message || 'Validation failed',
                errors: err.response.data?.errors || {}
            }
        }

        // Handle other errors
        if (err?.response?.status !== 200) {
            toast.error(err?.message, { duration: 4000 })
            return {
                error: true,
                message: err.response?.data?.message || err?.message || 'An error occurred',
                errors: err.response?.data?.errors || {}
            }
        }

        // For unexpected errors
        return {
            error: true,
            message: 'An unexpected error occurred',
            errors: {}
        }
    }
})

// update
export const deletePromoCode = createAsyncThunk('deletePromoCode', async (data,{dispatch}) => {
  try {
      const response = await axios.post(apis.delete_Promo, {...data},{
          headers: apiHeaders()
      })

      if (response?.data?.success ==='true'){
        await dispatch(getPromoCodes())
          toast.success("Promo code  deleted successfully",{duration:3000})

      }else {
          //console.log(response?.data)
      }

  }catch (err){
      //console.log(err)
      if (err?.response?.status!==200){
          toast.error(err?.message,{duration:4000})
      }
  }
})

export const getPromocodeId = createAsyncThunk('getPromocodeId', async (id) => {
  try {
      const response = await axios.get(apis.promo_code_id+id,{
          headers: apiHeaders()
      })
      return  response?.data

  }catch (err){  
      if (err?.response?.status!==200){
          return {
              data : [],
              errors:err?.response?.data?.errors
          }
      }
  }

}) 
// service_by_category
export const SevicesbyCategory = createAsyncThunk('SevicesbyCategory', async (data,{dispatch}) => {
  try {
      const response = await axios.post(apis.service_by_category, {...data},{
          headers: apiHeaders()
      })
      //console.log("data", response?.data)
      return  response?.data


  }catch (err){
      //console.log(err)
      if (err?.response?.status!==200){
          toast.error(err?.message,{duration:4000})
      }
  }
})


export const getPromoCodes = createAsyncThunk("getPromoCodes", async (status, { getState }) => {
  //console.log('API called with status:', status); // Log the status

  const { search, pageLimit, currentPage } = getState().clinicPromoStore; 
  let url = apis.promo_code;

  // Add status filter if present and not "All"
  if (status && status !== "All") {  
    url += `?status=${status}`;
  }

  // Add search filter if present
  if (search) {
    // Append '&' or '?' based on whether the status parameter is already present
    url += url.includes('?') ? `&search=${search}` : `?search=${search}`;
  }

  try {
    const response = await axios.get(url, {
      headers: apiHeaders(),
    });    

    if (response?.data?.success === "true") {
      return response?.data;   
    } else {
      return [];
    }
  } catch (err) {
    return [];
  }
});

export const updatepromoFilter = createAsyncThunk('updatepromoFilter', async (data) => {
  return data
})
export const clinicPromoSlice = createSlice({
    name: 'clinicPromoSlice',
    initialState: {
        services: [], 
        meta: {},
        links: {},
        search:'', 
      
        pageLimit:10,
        currentPage:1,
        Promos:[],
        servicess:[],
    },
    reducers: {
    }, 
    extraReducers: builder => {
      // 
      
            builder.addCase(getPromoCodes.fulfilled, (state, action) => {
              state.Promos = action.payload
          })
          builder.addCase(SevicesbyCategory.fulfilled, (state, action) => {
            state.servicess = action.payload
        })
        builder.addCase(updatepromoFilter.fulfilled, (state, action) => {
          const { search, pageLimit, currentPage } = action.payload; 
         
          if (search){
              state.search = search === 'reset' ? '' : search ;
          }
          if (currentPage){
            state.currentPage = currentPage ;
        }
         
      });
    }
})


export default clinicPromoSlice.reducer